import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type UpsertMeasurementInput,
	upsertStageMeasurement,
} from "@/adapters/api";
import { invalidateStageTree } from "@/features/stages/utils/query-keys.ts";
import { measurementKeys } from "../utils/query-keys.ts";

export function useUpsertMeasurement(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			stageId,
			input,
		}: {
			stageId: string;
			input: UpsertMeasurementInput;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return upsertStageMeasurement(constructionId, stageId, input);
		},
		onSuccess: () => {
			for (const queryKey of [
				measurementKeys.construction(constructionId),
				["schedules", constructionId],
			]) {
				queryClient.invalidateQueries({ queryKey });
			}
			return invalidateStageTree(queryClient, constructionId);
		},
	});
}
